import type { FaireProductEntity } from "../../entity_types/product";

export const p_ruq8th2tc6: FaireProductEntity = {
  token: "p_ruq8th2tc6",
  type: "product",
  name: "Moroccan Bodega Glasses",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/95b7266d5bda76b6332d93f9f80b8981d818f82528d2b154c7d1b6798cbe36b7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bbd721f257c48887160be8277c1234aee88f5cf318be8d0f193c72f08dc5757f.jpeg",
    "https://cdn.faire.com/fastly/4f2ccc479af87d2b749e5e1d0deefc11f438246708feedb915d61e6d2d4c0c60.jpeg",
    "https://cdn.faire.com/fastly/a4907822503ed4e77e773c5d9658abf8e5a3b9d285b59d814554dc1d7b2093ba.jpeg",
    "https://cdn.faire.com/fastly/e37f07467aafec7751fee2f3248a5370c75dd0e7d22b4b51f608fffea04649c7.jpeg",
    "https://cdn.faire.com/fastly/4e95d4db40b183f0cf637684eff1ad50a4a9cee421715b1f77f57215c2b16e56.jpeg",
  ],
  priceDollars: 3.75,
  description:
    "**Packaged in sets of 6** - 24 single glasses in a case pack\n\nThe newest addition to our Best-Selling Moroccan Glassware Collection, our new handblown Bodega Glasses are the perfect blend of contemporary and artisan. Crafted from recycled glass by master glass blowers, each piece bears the subtle bubbles and variations that make it entirely unique. Their versatile, timeless Spanish Wine Glass shape makes them perfect for everything from a morning espresso to a sunset cocktail, pairing beautifully with our matching pitchers, wine glasses, and tumblers for a table that tells a story of tradition, beauty, and shared moments.\n\nGlasses are handblown, variation in size is to be expected.\n\nPackaged in sets of 6 in traditional Moroccan gift packaging.\n\nDimensions: 3'' diameter x 2'' high, 5 fl oz capacity",
  tags: [],
  msrpDollars: 7.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:15.242Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
